import { type schemaType } from '~~/shared/api/rurality/v3/cottages/detail/closed-dates/schema'
import { type paramsType } from '~~/shared/api/rurality/v3/cottages/detail/closed-dates/paramsSchema'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/rurality/v3/cottages/detail/closed-dates`

  const { data } = await useFetch<any>(url, {
    body: { ...params },
    method: 'POST',
    key: url,
  })

  return data.value as returnType
}

export const browserFetch = async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/rurality/v3/cottages/detail/closed-dates`

  const data = await $fetch<any>(url, {
    body: { ...params },
    method: 'POST',
  })

  return data as returnType
}
